import { render, staticRenderFns } from "./modalOtrosMedidosIngreso.vue?vue&type=template&id=06572e4d&scoped=true&"
import script from "./modalOtrosMedidosIngreso.vue?vue&type=script&lang=js&"
export * from "./modalOtrosMedidosIngreso.vue?vue&type=script&lang=js&"
import style0 from "./modalOtrosMedidosIngreso.vue?vue&type=style&index=0&id=06572e4d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06572e4d",
  null
  
)

export default component.exports